export default class GetTipoConvocatoriaById {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(id) {
    try {
      const result = await this.#repository.getTipoConvocatoriaById(id)
      return result
    } catch (error) {
      console.error('Error al obtener el tipo de convocatoria:', error)
      throw error
    }
  }
}
